export class RequiredSupportingDocumentsNotAttached extends Error {
  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, RequiredSupportingDocumentsNotAttached.prototype)
  }
}
